import React, { useEffect } from 'react';
import { useField } from 'formik';
// import { useTranslation } from 'react-i18next';

import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { numToLetter } from '~/commons/helpers';

const FieldsMultiSelect = ({
  idx,
  qtnIndex: i,
  restrictEdit = false,
}) => {
  const [, { value }] = useField(`questionSets[${idx}].questions.${i}`);
  const [, , { setValue: setAns }] = useField(`questionSets[${idx}].questions.${i}.answers`);
  // const { t } = useTranslation();
  const { answers } = value;
  let { choices } = value;

  // take out the last empty choice
  if (!restrictEdit && !choices.slice(-1)[0]) {
    choices = choices.slice(0, -1);
  }

  useEffect(() => {
    if (answers.find((a) => a >= choices.length)) {
      setAns(answers.filter((a) => a < choices.length));
    }
  }, [choices.length]);
  useEffect(() => {
    if (!value?.answers?.length) {
      setAns([]);
    }
  }, []);

  return (
    <>
      <label>答案 *</label>
      <FieldArrayIterables
        name={`questionSets[${idx}].questions.${i}.choices`}
        {...restrictEdit ? {} : {
          tail: '',
        }}
      >
        {(c, ii) => (
          <div
            className="form-row align-items-center"
            key={ii}
          >
            <div className="col-auto pb-3">
              {numToLetter(ii, true)}.
            </div>
            <div className="col">
              <FormGroup
                checkbox={{
                  name: `questionSets[${idx}].questions.${i}.answers`,
                  value: ii.toString(),
                  disabled: ii >= choices.length,
                }}
                name={`questionSets[${idx}].questions.${i}.choices.${ii}`}
                label={null}
              />
            </div>
          </div>
        )}
      </FieldArrayIterables>
    </>
  );
};

export default FieldsMultiSelect;
